
import Vue from "vue";
import Component from "vue-class-component";

import NavBread from "../component/NavBread.vue";
import FormInfo from "./FormInfo.vue";

import {
  productBasicInfoLabel,
  productBasicInfoLabelForJY,
  projectBasicInfoLabel,
  productProcessLabel,
  projectProcessLabel,
} from "./conf";
import { Getter, Action } from "vuex-class";
import { Watch } from "vue-property-decorator";
import * as util from "../conf";
import { Message, MessageBox } from "element-ui";
import rely from "@/nmb/oauth2/oauth2rely";
import moment from "moment";
import XEUtils from "xe-utils";

@Component({
  components: {
    NavBread,
    FormInfo,
  },
})
export default class TransferDetail extends Vue {
  $refs: {
    [key: string]: any;
    validate: HTMLFormElement;
  };

  @Getter feedbackDetailV2: any; // 反馈信息
  @Getter feedbacktransferResult: any; // 操作结果标识
  @Getter transferResult: any; // 接收
  @Getter exsitFeedbacktransfer: any; // 是否存在转单信息
  @Getter feedbacktransferList: any; // 转单信息

  @Action getFeedbackDetailByIdV2: Function;
  @Action getFeedbackTransfer: Function; // 查询转单信息
  @Action receiveTransfer: Function; // 接收转单
  @Action rejectionTransfer: Function; // 拒收
  @Action urgeTransfer: Function; // 崔接收
  @Action cancelTransfer: Function; // 撤销
  navData: any = [
    { name: "反馈中心", to: { path: "/feedback" } },
    { name: "转单详情" },
  ];

  centerDialogVisible: boolean = false;

  showFeedbackInfo: boolean = false; // 是否展开详情

  TypeEnum: number = 0; // 反馈类型(1:产品咨询;2:产品建议;3:产品BUG)
  basicInfoLabel: any = JSON.parse(productBasicInfoLabel); // 基本信息的表单lebel
  processLabel: any = productProcessLabel; // 进展信息的表单lebel
  detailInfo: any = {};
  detailList: any = [];
  formInfo: any = {}; // 当前显示的产品进展
  user: any = {};
  showBtn: boolean = true; // 按钮显示
  tabProcess: string = "产品进展0"; // 进展tab标签
  subdisabled: boolean = false;
  rejectReason: String = "";
  FeedbackTransferGUID: any; // 当前转单GUID
  cardData: any = {}; //转单信息
  currentFeedback: any = {}; // 当前转单信息

  created() {
    this.TypeEnum = Number(this.$route.query.TypeEnum);
    this.getFeedbackDetailByIdV2({
      FeedbackGUID: this.$route.query.FeedbackGUID,
    });
    this.getFeedbackTransfer({
      FeedbackGUID: this.$route.query.FeedbackGUID,
    });

    this.user = JSON.parse(localStorage.logonUser);
    this.FeedbackTransferGUID = this.$route.query.FeedbackTransferGUID;
  }

  refresh(val: any) {
    this.subdisabled = val;
  }

  back(){
    this.$router.replace({path: "/feedback?activeIndex=" + this.$route.query.activeIndex});
  }

  mounted() {
    this.basicInfoLabel =
      this.tabProcess.indexOf("产品进展") > -1
        ? JSON.parse(productBasicInfoLabel)
        : JSON.parse(projectBasicInfoLabel);
    this.processLabel =
      this.tabProcess.indexOf("产品进展") > -1
        ? productProcessLabel
        : projectProcessLabel;
    if (this.TypeEnum === 2) {
      this.basicInfoLabel = JSON.parse(productBasicInfoLabelForJY);
    }
  }

  // 操作后，刷新页面
  @Watch("feedbacktransferResult.loading")
  watchFeedbacktransferResult(newVal: boolean, oldVal: boolean) {
    if (oldVal === true && newVal === false) {
      if (this.feedbacktransferResult.success) {
        Message.success(this.feedbacktransferResult.message);
        setTimeout(() => {
          this.$router.go(0);
        }, 500);
      }
    }
  }

  @Watch("feedbackDetailV2.loading")
  watchFeedbackDetail(newVal: boolean, oldVal: boolean) {
    if (oldVal === true && newVal === false) {
      const jiraDetails = this.feedbackDetailV2.data.JiraDetails || [];
      const pdDetails = this.feedbackDetailV2.data.PdDetails || [];
      this.detailList = [jiraDetails, pdDetails];
      if (jiraDetails.length > 0) {
        this.tabProcess = "产品进展" + (jiraDetails.length - 1);
        this.formInfo = jiraDetails[jiraDetails.length - 1];
      } else if (pdDetails.length > 0) {
        this.tabProcess = "项目进展" + (pdDetails.length - 1);
        this.formInfo = pdDetails[pdDetails.length - 1];
      }

      const user = rely.getLogonUser();
      this.detailInfo = this.feedbackDetailV2.data || {};

      this.processLabel =
        this.tabProcess.indexOf("产品进展") > -1
          ? productProcessLabel
          : projectProcessLabel;
      if (this.formInfo.SourceEnum === 2) {
        this.basicInfoLabel = JSON.parse(projectBasicInfoLabel);
      }
    }
  }

  @Watch("feedbacktransferList.loading")
  watchFeedbacktransferList(newVal: boolean, oldVal: boolean) {
    if (oldVal === true && newVal === false) {          
      // 通过url 获取FeedbackDetailsGUID
       this.currentFeedback =
        this.feedbacktransferList.data.find(
          (item: any) => item.FeedbackTransferGUID === this.FeedbackTransferGUID
        ) || {};

      this.showBtn = this.currentFeedback.StatusEnum == 1; // 控制按钮是否显示

      const jiraDetails = this.feedbackDetailV2.data.JiraDetails || [];
      const pdDetails = this.feedbackDetailV2.data.PdDetails || [];
      const details = [...pdDetails, ...jiraDetails];

      this.formInfo = details.find(
        (item: any) =>
          item.FeedbackDetailsGUID === this.currentFeedback.BeforeFeedbackDetailsGUID
      );

      const index = details.findIndex(
        (item: any) =>
          item.FeedbackDetailsGUID === this.currentFeedback.BeforeFeedbackDetailsGUID
      );

      // 切换转单信息
      this.tabProcess = "产品进展" + index;
      
      this.cardData = this.feedbacktransferList.data.find(
        (item: any) =>
          item.FeedbackTransferGUID === this.FeedbackTransferGUID
      )||{};
      
    }
  }
  // 接收
  handleReceive() {
    const data = this.feedbackDetailV2.data || {};
    const params = this.$refs.baseInfoForm.submitTransform();

    this.receiveTransfer({
      FeedbackGUID: data.FeedbackGUID,
      FeedbackTransferGUID: this.FeedbackTransferGUID,
      TypeEnum: data.TypeEnum,
    });
  }

  // 拒收
  handleReject() {
    this.centerDialogVisible = true;
  }
  // 拒收提交
  handleRejectSubmit() {
    if (this.rejectReason == "" || XEUtils.isEmpty(this.rejectReason)) {
      Message.error("拒绝理由不能为空！");
      return;
    }

    this.rejectionTransfer({
      FeedbackTransferGUID: this.FeedbackTransferGUID,
      RejectionReason: this.rejectReason,
    });
  }

  // 撤单
  handleCancel() {
    this.cancelTransfer({ feedbackTransferGUID: this.FeedbackTransferGUID });
  }

  // 催接收
  handleUgry() {
    const data = this.feedbackDetailV2.data || {};
    this.urgeTransfer({ feedbackTransferGUID: this.FeedbackTransferGUID });
  }

  getTypeEnumUri() {
    switch (this.TypeEnum) {
      case 1:
        return "consultation";
      case 2:
        return "proposal";
      case 3:
        return "defect";
      default:
        return "";
    }
  }

  /**
   * 切换进展
   */
  changeProcess(tab: string, data: string) {
    this.tabProcess = tab;
    this.processLabel =
      this.tabProcess.indexOf("产品进展") > -1
        ? productProcessLabel
        : projectProcessLabel;
    this.formInfo = data;

    // 切换转单信息
    this.cardData = this.feedbacktransferList.data.find(
      (item: any) =>
        item.BeforeFeedbackDetailsGUID === this.formInfo.FeedbackDetailsGUID
    );
    this.cardData = this.cardData ? this.cardData : {};
  }
  // 时间转换
  setTime(time: string) {
    return time ? moment(time).format("YYYY-MM-DD") : "--";
  }
}
